type ApiConfig = {
  origin: string;
  prefix: string;
};

function normalizePrefix(prefix: string): string {
  if (!prefix) return "";
  const trimmed = prefix.trim();
  if (!trimmed) return "";
  const withLeadingSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return withLeadingSlash.replace(/\/+$/, "");
}

function getApiConfig(): ApiConfig {
  const raw = typeof __CHECKRIDE_API_BASE_URL__ === "string" ? __CHECKRIDE_API_BASE_URL__ : "";
  const value = raw.trim();

  // Default to same-origin + /api so we can host UI at / and API behind /api via reverse proxy.
  if (!value) {
    return { origin: window.location.origin, prefix: "/api" };
  }

  // Allow configuring a same-origin prefix like "/api".
  if (value.startsWith("/")) {
    return { origin: window.location.origin, prefix: normalizePrefix(value) };
  }

  // Allow configuring a full URL like "https://api.example.com" or "https://example.com/api".
  const url = new URL(value);
  return { origin: url.origin, prefix: normalizePrefix(url.pathname) };
}

export function apiUrl(pathname: string): URL {
  const { origin, prefix } = getApiConfig();
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const fullPath = `${prefix}${normalizedPath}`.replace(/\/\/+/, "/");
  return new URL(fullPath, origin);
}
